import React from 'react'
import SectionType from 'models/types/ts/sectionType'
import ContentType from 'models/types/ts/contentType'
import { Container, Heading } from 'layouts'
import { HeadingXSmall, ParagraphRegular } from 'layouts/typography'
import style from './Benefits.module.scss'

interface Props {
    section: SectionType
}

const Benefits = ({ section }: Props): JSX.Element => {
    const {
        headline,
        body,
        contentCollection: { total, items },
    } = section

    const secondColumnStart = Math.ceil(total / 2)

    const benefit = (item: ContentType): JSX.Element => (
        <div className={style.item} key={item.headline}>
            {item.imageFile && <img src={item.imageFile.url} alt="" />}
            <HeadingXSmall>{item.headline}</HeadingXSmall>
            <ParagraphRegular>{item.body}</ParagraphRegular>
        </div>
    )

    return (
        <div className={style.benefits}>
            <Container>
                <Heading size="regular">{headline}</Heading>
                <p className={style.intro}>{body}</p>
                {total > 0 && (
                    <div className={style.content}>
                        <div className={style.col}>
                            {items
                                .slice(0, secondColumnStart)
                                .map((item) => benefit(item))}
                        </div>
                        <div className={style.col}>
                            {items
                                .slice(secondColumnStart)
                                .map((item) => benefit(item))}
                        </div>
                    </div>
                )}
            </Container>
        </div>
    )
}

export default Benefits
